
import 'babel-polyfill';
import core from 'Core/core';

function components () {
	// Import all components matching *.js except *.partial.js and *.config.js
	const files = require.context('Components', true, /^(?!.*(?:partial|config.js|template.js$)).*\.js$/); // error if 'Components' is a variable.
	files.keys().forEach(files);
}

function containers () {
	// Import all containers matching *.js except *.partial.js and *.config.js
	const files = require.context('Containers', true, /^(?!.*(?:partial|config.js|template.js$)).*\.js$/); // error if 'Containers' is a variable.
	files.keys().forEach(files);
}

core();
components();
containers();
